$(document).ready(function() {
  //导航经过
  $(".NavTop ul")
    .mouseover(function() {
      $(".NavTop").addClass("active");
      $(".sub_menu").addClass("active");

      $(".navBtn span").addClass("active");
    })
    .mouseout(function() {
      $(".NavTop").removeClass("active");
      $(".sub_menu").removeClass("active");

      $(".navBtn span").removeClass("active");
    });
  var a = 0;
  $(document).scroll(function() {
    var Q = $(document).scrollTop();
    let theme = localStorage.getItem("theme")
    let color = "#3385ff"  // 默认蓝色
    if(theme == 'red') {  // 红色主题
      color = "rgba(174, 28, 28, 1)"
    }
    
    if (Q > 60 && a === 0) {
      $(".header").css({
        background: color
      });
      // $(".header").css({
      //   "background-color": "#020b12",
      //   background: "rgba(2,10,34,.8)"
      // });
      // $(".header_o").css({
      //   "background-color": "#020b12",
      //   background: "rgba(2,10,34,.8)"
      // });
      a = 1;
    }
    if (Q < 60 && a === 1) {
      // $(".header").css({"background":"none"})
      // $(".header_o").css({
      //   "background-color": "#020b12",
      //   background: "rgba(2,10,34,.8)"
      // });
      //   20210823 非首页时，页面滚动再回到最上菜单栏底色会变成透明，看不到菜单
      // $(".header").css({ background: "#3385ff" });
      $(".header").css({ background: "" });
      a = 0;
    }
  });

  // var qcloud={};
  // $('[_t_nav]').hover(function(){
  //     var _nav = $(this).attr('_t_nav');

  //     clearTimeout( qcloud[ _nav + '_timer' ] );

  //     qcloud[ _nav + '_timer' ] = setTimeout(function(){

  //     $('[_t_nav]').each(function(){

  //     $(this)[ _nav == $(this).attr('_t_nav') ? 'addClass':'removeClass' ]('nav-up-selected');

  //     });

  //     $('#'+_nav).stop(true,true).slideDown(200);

  //     }, 150);

  // },function(){

  //     var _nav = $(this).attr('_t_nav');

  //     clearTimeout( qcloud[ _nav + '_timer' ] );

  //     qcloud[ _nav + '_timer' ] = setTimeout(function(){

  //     $('[_t_nav]').removeClass('nav-up-selected');

  //     $('#'+_nav).stop(true,true).slideUp(200);

  //     }, 150);

  // });
});



// WEBPACK FOOTER //
// ./src/assets/js/menu.js